export interface PasswordsForm {
  currentPassword: string;
  new: string;
  confirm: string;
}

export class CompleteNewPasswordFormValues implements Partial<PasswordsForm>
{
    currentPassword='';
    new = '';
    confirm = '';
    email = '';
}
